<template>
  <div class="infinite-scroll">
    <div 
      ref="infiniteScroll"
      :style="{ 'max-height': maxHeight }"  
      class="infinite-scroll__container" 
    >
      <slot />
    
      <div 
        v-if="lastItems"
        class="last_items"
      >
        Não há mais dados para exibir
      </div>
    </div>

    <AppLoadingIcon 
      v-if="loading"
      class="loading" 
      color="#BBB"
    />
  </div>
</template>

<script>
import AppLoadingIcon from './AppLoadingIcon'
export default {
  name: 'AppInfiniteScroll',
  components: {
    AppLoadingIcon
  },
  props: {
    loading: {
      type: Boolean,
      default: false
    },
    lastItems: {
      type: Boolean,
      default: false
    },
    maxHeight: {
      type: String,
      default: '250px' 
    },
    delay: {
      type: Number,
      default: 300
    }
  },
  data() {
    return {
      lastScrollPosition: 0
    }
  },
  mounted() {
    this.$refs.infiniteScroll.addEventListener('scroll', this.onScroll)
  },
  methods: {
    /**
     * @name onScroll
     * @event nextPage
     * @return void
     */
    onScroll() {
      const list = this.$refs.infiniteScroll
      const scrollDown = list.scrollTop > this.lastScrollPosition
      const hitEndScroll = list.scrollTop + list.clientHeight >= list.scrollHeight - 50
      if (!this.loading && scrollDown && hitEndScroll) {
        this.debounce(this.onScrollHitEnd)
      }
    },
    /**
     * Emite evento e salva a última posição do scroll
     */
    onScrollHitEnd() {
      this.$emit('nextPage')
      this.lastScrollPosition = this.$refs.infiniteScroll.scrollTop
    },
    /**
     * Debounce para não emitir muitos eventos de uma vez
     * @param method 
     */
    debounce(method) {
      clearTimeout(method._id)
      method._id = this.emitEventDebounce = setTimeout(() => {
        method()
      }, this.delay)
    }
  },
  beforeDestroy() {
    this.$refs.infiniteScroll.removeEventListener('scroll', this.onScroll)
  }
}
</script>
<style lang="stylus" scoped>
  .infinite-scroll
    position relative
    height 100%

    &__container
      overflow-y scroll
    .loading
      position absolute
      bottom 20px
      left calc(50% - 48px)
    
    .last_items
      color rgba(0,0,0,.6)
      margin 10px auto
      text-align center
      font-weight 400
      font-size 13px

	/* width */
    &::-webkit-scrollbar
      width 10px
    
    /* Track */
    &::-webkit-scrollbar-track
      background transparent

    /* Handle */
    &::-webkit-scrollbar-thumb
      background #888
      border-radius 10px

    /* Handle on hover */
    &::-webkit-scrollbar-thumb:hover
      background #555
</style>